import { Key, useEffect, useState } from "react";
import * as React from "react";
import "../../../Styles/main.scss"
import { VectorDown, VectorUp } from "../Components/SvgIcons"

interface EdusiiaItems {
    id: number
    name: string
}

function Dropdown(props: { placeholder: string; items: EdusiiaItems[]; itemId: null | number; setItemId: Function, selectModifier?: string, dropdownModifier?: string } & React.HTMLAttributes<HTMLDivElement>) {
    const [expanded, setExpanded] = useState(false)
    const [selected, setSelected] = useState("")
    const [isSelected, setIsSelected] = useState(false)

    const DropdownRef = React.useRef<HTMLDivElement>(null)

    useEffect(() => {
        if(props.itemId){
            setSelected(props.items.find((item: { id: number }) => item.id === props.itemId)?.name || "")
            setIsSelected(true)
            setExpanded(false)
        }
    }, [props.itemId])

    const onDropdownOpen = () => {
        setExpanded(!expanded)
    }

    useEffect(() => {
        const onMouseDownHandler = (event: Event) => {
            if (expanded && DropdownRef.current && !DropdownRef.current.contains(event.target as HTMLElement)) {
                setExpanded(false)
            }
        }
        document.addEventListener("mousedown", onMouseDownHandler)
        return () => document.removeEventListener("mousedown", onMouseDownHandler)
    }, [expanded])

    const onDropdownKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            setExpanded(!expanded)
        } else if (event.key === "Escape") {
            setExpanded(false)
        }
    }

    const onItemClick = (items: { id: Key; name: string }) => {
        const value = items.name
        setSelected(value)
        setIsSelected(true)
        props.setItemId(items.id)
        setExpanded(false)
    }

    return (
        <>
            <div ref={DropdownRef} className={`dropdown ${props.dropdownModifier ? props.dropdownModifier : ""}`}>
                <div 
                    className={`dropdown__select ${props.selectModifier ? props.selectModifier : ""}`} 
                    onClick={onDropdownOpen} 
                    onKeyDown={onDropdownKeyDown}
                    role="combobox"
                    tabIndex={0}
                    aria-expanded={expanded}
                    aria-haspopup="listbox"
                    data-testid="dropdown-select"
                >
                    <input
                        className="dropdown__select-input dropdown__default-cursor"
                        placeholder={props.placeholder}
                        autoComplete="off"
                        value={isSelected ? selected : ''}
                        readOnly
                    />
                    <div className="dropdown__icon">{expanded ? <VectorUp /> : <VectorDown />}</div>
                </div>
                {expanded && (
                    <div className="dropdown__container " role="listbox" data-testid="dropdown-container">
                        <div className="dropdown__content">
                            {props.items?.map((item: { id: number; name: string }) => (
                                <div
                                    className={selected === item.name ? "dropdown__item--selected-true" : "dropdown__item"}
                                    onClick={() => onItemClick(item)}
                                    key={item.id}
                                    role="option"
                                    aria-selected={selected === item.name}
                                    data-testid={`dropdown-item${item.id}`}
                                >
                                    <p className="dropdown__text">{item.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
export default Dropdown
